import { createFileRoute } from '@tanstack/react-router'
import { ScTimeEntriesPage } from '@/features/support-coordination/time-entries'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/time-entries',
)({
  component: ScTimeEntriesPage,
})
